import { Alert, Breadcrumbs, Link, Typography } from "@mui/material"
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar"
import { Link as LinkTo } from 'react-router';
import { BackButton } from "../../../../../common/components/back_button"
import { FormSwitchInput } from "../../../../../common/components/masked_inputs/react_forms/form_switch_input"
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal"
import { useUsuariosCadastroViewModel } from "../../viewModels/usuarios_cadastro_view_model"
import { DropDownFuncionario } from "../../../../../common/components/dropdown_funcionario"
import { FormRadioGroupInput } from "../../../../../common/components/masked_inputs/react_forms/form_radio_group_input"
import { TabelaGrupoAcesso } from "./components/tabela_grupo_acesso";
import { TabelaCentroCustoRestricao } from "./components/tabela_centro_custo_restricao";

import RefreshButton from "../../../../../common/components/refresh_button"
import PrimaryButton from "../../../../../common/components/primary_button"
import DynamicIcon from "../../../../../common/components/dynamic_icon"
import AlertError from "../../../../../common/components/alert_error"
import DefaultFormInput from "../../../../../common/components/default_form_input"
import FormContainer from "../../../../../common/components/form_container"
import DeleteDialog from "../../../../../common/components/delete_dialog"
import BottomBar from "../../../../../common/components/bottom_bar"
import DefaultFormPasswordInput from "../../../../../common/components/default_form_password_input"
import ValidatePassword from "../../../../../common/components/ValidatePassword"

/**
 * UsuariosCadastro
 */

export const UsuariosCadastro = () => {
    const viewModel = useUsuariosCadastroViewModel();
    return (
        <>
            <PageTopBar>
                <ThreeSlotLayout
                    rightSlot={
                        <div className="flex flex-row gap-2 ">
                            <BackButton
                                onClick={() => viewModel.handlePageBack()} />

                            <div className="w-[220px] ">
                                <PrimaryButton
                                    startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                                    onClick={() => viewModel.handleNewUsuario()}>
                                    Novo Usuário
                                </PrimaryButton>

                            </div>

                        </div>
                    }
                />
            </PageTopBar >

            <form className="pb-8" onSubmit={viewModel.handleUsuarioCadastroSubmit}>
                <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
                    <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
                        <Link underline="hover" color="inherit">
                            Home
                        </Link>
                        <Link underline="hover" color="inherit" component='span'>
                            <LinkTo to="/Usuarios_lista" >Usuários Lista</LinkTo>
                        </Link>
                        <Typography className="text-primary-green">
                            Usuário Cadastro
                        </Typography>
                    </Breadcrumbs>

                    <div className="div flex justify-start items-center flex-col md:flex-row gap-6 md:gap-0">
                        <div className="flex gap-2 items-center w-full">
                            <h1 className="text-3xl font-medium text-black dark:text-white">
                                Usuário Cadastro
                            </h1>
                            <RefreshButton onClick={viewModel.handleReload} />
                        </div>
                    </div>
                    {
                        (viewModel.selectedUsuario && viewModel.selectedUsuario.isConfigured === false) && (
                            <div className="w-full">
                                <Alert severity="warning">Este usuário ainda não foi configurado no novo sistema. Para configurá-lo, basta clicar em "Salvar alterações".</Alert>
                            </div>
                        )
                    }
                    {
                        viewModel.errorMessage !== undefined ? (
                            <div className="w-full">
                                <AlertError
                                    messageErro={viewModel.errorMessage}
                                    onTryAgain={viewModel.handleReload} />
                            </div>
                        ) : (
                            <>
                                <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
                                    <FormContainer title="Informações" arrangement="fullRow" border={false}>
                                        <div className="flex flex-col items-start w-[70%] gap-4">
                                            <div className=" w-[40%] flex items-start justify-between">

                                                <FormRadioGroupInput
                                                    name='bloqueado'
                                                    label='Status'
                                                    options={viewModel.statusOptions}
                                                    reactHookForm={viewModel.hookForm}
                                                />

                                            </div>

                                            <DefaultFormInput
                                                name='nome'
                                                label='Nome do Usuário'
                                                required={true}
                                                reactHookForm={viewModel.hookForm}
                                            />

                                            <DefaultFormInput
                                                name='login'
                                                label='Login'
                                                required={true}
                                                autoComplete="new-password"
                                                reactHookForm={viewModel.hookForm}
                                            />


                                            <DefaultFormPasswordInput
                                                name='senha'
                                                label='Senha'
                                                required={false}
                                                autoComplete="new-password"
                                                reactHookForm={viewModel.hookForm}
                                            />
                                            {
                                                viewModel.senha &&
                                                <>
                                                    <ValidatePassword
                                                        value={viewModel.senha}
                                                        isValid={(valid) => { }}
                                                    />

                                                    <DefaultFormPasswordInput
                                                        name='confirmarSenha'
                                                        label='Confirmar Senha'
                                                        required={false}
                                                        autoComplete="new-password"
                                                        reactHookForm={viewModel.hookForm}
                                                    />

                                                </>
                                            }

                                            <DefaultFormInput
                                                name='email'
                                                label='E-mail'
                                                required={true}
                                                reactHookForm={viewModel.hookForm}
                                            />
                                            <div className="w-full flex flex-col gap-4 mt-3 justify-start items-start md:items-center md:flex-row">
                                                <div className="w-[60%]">
                                                    <DropDownFuncionario
                                                        name='idFuncionario'
                                                        label='Funcionário'
                                                        required={false}
                                                        readOnly={viewModel.saving}
                                                        reactHookForm={viewModel.hookForm}
                                                    />
                                                </div>
                                            </div>

                                            <div className=" w-[40%] flex items-start justify-between">
                                                <label className="font-medium text-gray-700">Restrição de acesso por centro de custo:</label>
                                                <FormSwitchInput
                                                    activeLabel="Sim"
                                                    inactiveLabel="Não"
                                                    name="centroCustoRestrito"
                                                    readOnly={viewModel.saving}
                                                    reactHookForm={viewModel.hookForm}
                                                />
                                            </div>
                                        </div>
                                    </FormContainer>

                                    <div className="w-full flex flex-col md:flex-row gap-6 m-3">
                                        <TabelaGrupoAcesso
                                            loading={viewModel.loading}
                                            saving={viewModel.saving}
                                            gridRowSelectionModel={viewModel.grupoAcessoSelectionModel ?? { type: 'include', ids: new Set() }}
                                            grupoAcessos={viewModel.grupoAcessoUsuarioLista ?? []}
                                            page={viewModel.pagination.grupoAcessoUsuario.page}
                                            rowsPerPage={viewModel.pagination.grupoAcessoUsuario.rowsPerPage}
                                            totalItems={viewModel.pagination.grupoAcessoUsuario.totalItems}
                                            onPageChange={viewModel.handleGrupoAcessoPageChange}
                                            onRowsPerPageChange={viewModel.handleGrupoAcessoRowsPerPageChange}
                                            onSelectionModelChange={viewModel.handleGrupoAcessoSelectionModelChange}

                                        />
                                    </div>

                                    {
                                        viewModel.centroCustoRestrito &&
                                        <div className="w-full flex flex-col md:flex-row gap-6 m-3">
                                            <TabelaCentroCustoRestricao
                                                loading={viewModel.loading}
                                                saving={viewModel.saving}
                                                gridRowSelectionModel={viewModel.centroCustoRestritoSelectionModel ?? { type: 'include', ids: new Set() }}
                                                centroCustoRestricoes={viewModel.restricaoCentroCustoUsuarioLista ?? []}
                                                page={viewModel.pagination.centroCustoRestricaoUsuario.page}
                                                rowsPerPage={viewModel.pagination.centroCustoRestricaoUsuario.rowsPerPage}
                                                totalItems={viewModel.pagination.centroCustoRestricaoUsuario.totalItems}
                                                onPageChange={viewModel.handleCentroCustoRestritoPageChange}
                                                onRowsPerPageChange={viewModel.handleCentroCustoRestritoRowsPerPageChange}
                                                onSelectionModelChange={viewModel.handleCentroCustoRestritoSelectionModelChange}

                                            />
                                        </div>
                                    }

                                </div>
                            </>
                        )
                    }

                </div>

                <BottomBar>
                    <div className="w-full h-full flex justify-between items-center p-4 gap-6">
                        <div>
                            {
                                viewModel.selectedIdUsuario &&
                                <>
                                    <div>
                                        <PrimaryButton
                                            buttonColor="yellow"
                                            onClick={() => viewModel.handleOpenChangeHistory(viewModel.selectedIdUsuario ?? null, null)}>
                                            <span className="text-xs">
                                                Historico de alterações
                                            </span>
                                        </PrimaryButton>
                                    </div>
                                </>
                            }
                        </div>

                        <div className="w-full h-full flex justify-end items-center p-4 gap-6">

                            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                                <h1 className="text-sm text-black dark:text-white" onClick={() => viewModel.handlePageBack()}>
                                    Cancelar
                                </h1>
                            </div>

                            <div className="w-40">
                                {viewModel.saving ? (
                                    <PrimaryButton>Salvando...</PrimaryButton>
                                ) : (
                                    <PrimaryButton
                                        type="submit"
                                        startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}
                                    >
                                        Salvar
                                    </PrimaryButton>
                                )}
                            </div>
                        </div>
                    </div>
                </BottomBar>
            </form>

            <DeleteDialog
                open={viewModel.openDeleteModal}
                saving={viewModel.saving}
                onClose={() => viewModel.handleUsuarioDeleteOpenState(false)}
                title={`Você realmente deseja excluir este arquivo?`}
                onDelete={viewModel.handleConfirmarDeletarUsuario}
            />


            <ChangeHistoryModal changeHistoryHandler={viewModel.changeHistory} />
        </>
    )
}



